import { jsx as o, jsxs as P } from "react/jsx-runtime";
import { useTranslation as le, PaymentMethodEnum as T, getPaymentMethodTitle as ce, FieldErrorAndDescription as me } from "@systemeio/ui";
import { useWatch as m } from "@systemeio/util";
import de from "isomorphic-dompurify";
import { useState as j } from "react";
import pe from "../../../components/layout.mjs";
import ue from "../../../components/store-image.mjs";
import fe from "../../../components/affiliate-badge.mjs";
import he from "../../../components/field.mjs";
import ge from "../../../components/full-screen-card-wrapper.mjs";
import { PaymentMethodIcon as ye } from "../../../components/payment-method-icon.mjs";
import { usePaymentProcessors as Pe } from "../../../payment-processors/index.mjs";
import { useOfferStore as xe } from "../../../store/index.mjs";
import { getDeepCopiedObject as be } from "../../../utils/get-deep-copied-object.mjs";
import { getDefaultFieldValues as Ee } from "../../../utils/get-default-field-values.mjs";
import { hasErrors as Ce } from "../../../utils/has-errors.mjs";
import { parseErrors as Me } from "../../../utils/parse-errors.mjs";
import { offerDefaultErrors as d } from "../constants/default-errors.mjs";
import { useCatchCookiePurchaseError as Ne } from "../hooks/use-catch-cookie-purchase-error.mjs";
import { getDefaultCoverByProductType as _e } from "../utils/get-default-cover-by-type.mjs";
import { getMissingFieldsErrors as Fe } from "../utils/get-missing-fields-errors.mjs";
import { DigitalOrderSummary as Oe } from "./components/digital-order-summary.mjs";
import De from "../../../components/price-plan-info/price-plan-info.mjs";
import k from "../../../ui-kit/radio-group/radio-group-accordion.mjs";
const Ze = (x) => {
  var D, I, S;
  const { title: N, description: v, buttonTitle: A, fields: q, cover: b, offerId: E, digitalProductId: C, id: _ } = x.checkoutPage, {
    currency: w,
    paymentMethods: L,
    pricePlans: a,
    thankYouPage: M,
    affiliateLink: B,
    displayAffiliateLink: H,
    productType: R,
    calculatePrice: W,
    isLoadingCalculatePrice: $,
    skipDisabledButton: U = !1
  } = x, { t: n } = le(), [z, G] = j(!1), [c, p] = j(d);
  Ne({
    handlerError: (e) => p((t) => ({ ...t, common: [e] })),
    pagePath: x.checkoutPage.path
  });
  const {
    setAvailablePaymentMethods: V,
    setPaymentMethod: J,
    paymentMethod: f,
    availablePaymentMethods: u,
    setCurrency: K,
    setPricePlan: h,
    pricePlan: s,
    setOfferId: Q,
    setProductId: X,
    finalAmount: Y,
    setFinalAmount: g,
    contactFields: l,
    setContactFields: F
  } = xe();
  m(C, (e) => e && X(e)), m(E, (e) => e && Q(e)), m(L, (e) => e && V(e)), m(w, (e) => e && K(e)), m(q, (e) => e && F(Ee(e))), m(a, (e) => {
    if (e)
      if (e.length === 0)
        h(void 0), g(void 0);
      else if (s) {
        if (!e.some((r) => r.id === s.id)) {
          const r = e[0];
          h(r), g(r.amount);
        }
      } else {
        const t = e[0];
        h(t), g(t.amount);
      }
  });
  const Z = () => {
    let e = !1;
    const t = be({
      customer: d.customer,
      paymentMethod: d.paymentMethod,
      pricePlan: d.pricePlan
    });
    return Object.values(l).forEach(({ slug: r, value: i, required: y }) => {
      y && (i == null || i === "") && (t.customer.fields[r] = [n("public_pages_purchase.required-field")], e = !0);
    }), f || (t.paymentMethod = [n("public_pages_purchase.required-field")], e = !0), s || (t.pricePlan = [n("public_pages_purchase.required-field")], e = !0), { errors: t, isFailed: e };
  }, O = !!Y && !!f && !!E && !!C && !!s && !!_, ee = () => {
    if (!O) return;
    const e = Object.values(l).reduce((i, y) => (i[y.slug] = y.value ?? "", i), {}), t = `${window.location.origin}${(M == null ? void 0 : M.path) ?? ""}`, r = window.location.href;
    return {
      page: _,
      customer: {
        fields: e
      },
      offer: E,
      digitalProduct: C,
      purchaseProductModel: null,
      pricePlan: s.id,
      thankYouPageUrl: t,
      failedReturnUrl: r,
      paymentMethod: f
    };
  }, te = () => {
    p(d);
    const { errors: e, isFailed: t } = Z();
    if (t) {
      p((r) => ({ ...r, ...e }));
      return;
    }
    return ee();
  }, re = (e) => {
    const t = Me(e, d), r = Fe(t.customer.fields, l);
    p({
      ...t,
      common: t.common.concat(r)
    });
  }, { paymentProcessorPaymentButton: oe, paymentProcessorDetails: se, PaymentProcessorProvider: ae } = Pe({
    isFetching: z,
    setIsFetching: G,
    handleBadRequest: re,
    buttonTitle: A,
    buttonDisabled: !O && !U,
    preSubmit: te,
    setErrors: p,
    hasErrors: Ce(c)
  }), ie = Object.values(u).filter((e) => e !== T.stripe_applepay).filter((e) => e !== T.cash_on_delivery).map((e) => ({
    id: e,
    caption: n(ce(e, n)),
    content: se,
    additionalInfo: /* @__PURE__ */ o(ye, { paymentMethod: e })
  })), ne = a == null ? void 0 : a.map((e) => ({
    id: String(e.id),
    caption: e.name,
    additionalInfo: /* @__PURE__ */ o(De, { ...e })
  }));
  return /* @__PURE__ */ o(pe, { children: /* @__PURE__ */ P(ge, { children: [
    /* @__PURE__ */ o(ae, { children: /* @__PURE__ */ P("form", { className: "flex flex-col gap-5 px-5 pt-5 sm:gap-10 sm:pb-5", children: [
      /* @__PURE__ */ o(
        ue,
        {
          className: "h-full w-full shrink-0 rounded-lg",
          src: b == null ? void 0 : b.path,
          imageType: _e(R),
          alt: N
        }
      ),
      /* @__PURE__ */ P("div", { className: "flex flex-col gap-5 sm:gap-10", children: [
        /* @__PURE__ */ o("div", { className: "flex flex-col gap-3 sm:gap-5", children: /* @__PURE__ */ o("h2", { className: "text-xl font-bold sm:text-3xl", children: N }) }),
        /* @__PURE__ */ P("div", { className: "flex flex-col gap-3 sm:gap-5", children: [
          /* @__PURE__ */ o(
            "div",
            {
              className: "ckeditor-default text-sm sm:text-base sm:leading-5",
              dangerouslySetInnerHTML: {
                __html: de.sanitize(v)
              }
            }
          ),
          Object.values(l).map((e) => {
            const t = (r) => F({
              ...l,
              [e.slug]: { ...e, value: r }
            });
            return /* @__PURE__ */ o(
              he,
              {
                contactFields: l,
                field: e,
                value: l[e.slug].value,
                error: c.customer.fields[e.slug],
                onChange: t
              },
              e.slug
            );
          }),
          a && (a == null ? void 0 : a.length) > 0 && /* @__PURE__ */ o(
            k,
            {
              label: n("public_pages_purchase.payment.price_plan"),
              labelClassName: "mb-2",
              optionClassName: "text-THEME-text-secondary",
              selectedOptionClassName: "text-THEME-text-secondary",
              optionsWrapperClassName: "gap-3",
              options: ne,
              selected: String(s == null ? void 0 : s.id),
              onChange: (e) => {
                const t = Number(e), r = a.find((i) => i.id === t);
                r && (h(r), g(r.amount));
              },
              required: !0,
              error: (D = c.pricePlan) == null ? void 0 : D.join(", ")
            },
            `price-plan-${s == null ? void 0 : s.id}`
          ),
          s && /* @__PURE__ */ o(
            Oe,
            {
              calculatePrice: W,
              isLoading: $ ?? !1,
              pricePlan: s
            }
          ),
          u && (u == null ? void 0 : u.length) > 0 && /* @__PURE__ */ o(
            k,
            {
              label: n("public_pages_purchase.Payment-method"),
              labelClassName: "mb-2",
              optionClassName: "text-THEME-text-secondary",
              selectedOptionClassName: "text-THEME-text-secondary",
              optionsWrapperClassName: "gap-3",
              options: ie,
              selected: f,
              onChange: (e) => J(e),
              required: !0,
              error: (I = c.paymentMethod) == null ? void 0 : I.join(", ")
            }
          ),
          c.common && /* @__PURE__ */ o(
            me,
            {
              error: (S = c.common) == null ? void 0 : S.join(", "),
              errorClassName: "flex justify-center"
            }
          )
        ] }),
        oe
      ] })
    ] }) }),
    H && /* @__PURE__ */ o(fe, { affiliateLink: B })
  ] }) });
};
export {
  Ze as DigitalCheckout
};
